// ! TODO: Move to `components/`
import React from 'react';

import ReactDOM from 'react-dom';

import Flex from '@waglabs/flex';

import LoadingBoneSpinner from '../LoadingBoneSpinner/LoadingBoneSpinner';

type Props = {};

/**
 * @deprecated Use the <LoadingBone /> from the components
 */
export const LoadingBoneOverlay = (props: Props) => ReactDOM.createPortal(
  <Flex
    alignItems="center"
    bottom="0"
    justifyContent="center"
    left="0"
    position="fixed"
    right="0"
    top="0"
    zIndex={1400}
    {...props}
  >
    <LoadingBoneSpinner />
  </Flex>,
  // $FlowFixMe - safe to assume `document.body` is not `null`
  document.body,
);

export default LoadingBoneOverlay;
